import React from 'react';
import Summary from '../../TabsComponent/Summary';

const CompanySummaryPrint = ({ summary, itemsToExport }) => {
  if (!itemsToExport.value) return <></>;

  return <Summary summaryData={summary} />;
};

export default CompanySummaryPrint;
